import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
};

export const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishlist: (state, action) => {
      const item = state.products.find((item) => item.id === action.payload.id);
      if (item) {
        item.quantity += action.payload.quantity;
      } else {
        state.products.push(action.payload);
      }
    },
    removeItem: (state,action) => {
      state.products=state.products.filter(item=>item.id !== action.payload)
    },
    resetWishlist: (state) => {
      state.products = []
    },
  },
});

// Action creators are generated for each case reducer function
export const { addToWishlist,removeItem,resetWishlist } = wishlistSlice.actions;

export default wishlistSlice.reducer;
